import React, { FC } from 'react';

const MailToLink: FC<{ address: string }> = ({ address }) => (
    <a href={`mailto:${address}`}>{address}</a>
);

export default MailToLink;
